import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const poeorderApi = api
  .enhanceEndpoints({ addTagTypes: ['POEOrder'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOEOrders: builder.query<po_eorder[], string>({
        query: cid => `poeorder/${cid}`,
        providesTags: ['POEOrder'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (data.type === 'POS_ORDER_UPDATED') {
                dispatch(poeorderApi.util.invalidateTags(['POEOrder']));
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getPORunningOrders: builder.query<any[], string>({
        query: cid => `poeorder/running/${cid}`,
        providesTags: ['POEOrder']
      }),
      getPOEOrderByTable: builder.query<any[], any>({
        query: ({ cid, tbl }) => `poeorder/bytbl/${cid}/${tbl}`,
        providesTags: ['POEOrder']
      }),
      getPOKOTs: builder.query<any[], any>({
        query: ({ cid, tbl }) => `poeorder/bytblkots/${cid}/${tbl}`,
        providesTags: ['POEOrder']
      }),
      getPOEOrderById: builder.query<any, string>({
        query: id => `poeorder/byid/${id}`,
        providesTags: ['POEOrder']
      }),
      insertPOEOrder: builder.mutation({
        query: poeorder => ({
          url: `poeorder/`,
          method: 'POST',
          body: poeorder
        }),
        invalidatesTags: ['POEOrder']
      }),
      // Offline-queue replay: the Idempotency-Key makes a retried POST return the saved order instead of a duplicate
      insertPOEOrderIdem: builder.mutation<any, {order: any; key: string}>({
        query: ({order, key}) => ({
          url: `poeorder/`,
          method: 'POST',
          body: order,
          headers: {'Idempotency-Key': key}
        }),
        invalidatesTags: ['POEOrder']
      }),
      insertPOEOrderReady: builder.mutation({
        query: poeorder => ({
          url: `poeorder/ready/`,
          method: 'POST',
          body: poeorder
        }),
        invalidatesTags: ['POEOrder']
      }),
      updatePOEOrder: builder.mutation({
        query: poeorder => ({
          url: `poeorder/`,
          method: 'PUT',
          body: poeorder
        }),
        invalidatesTags: ['POEOrder']
      }),
      updatePOEOrderReady: builder.mutation({
        query: poeorder => ({
          url: `poeorder/ready/`,
          method: 'PUT',
          body: poeorder
        }),
        invalidatesTags: ['POEOrder']
      }),
      deletePOEOrder: builder.mutation({
        query: poeorder => ({
          url: `poeorder/${poeorder.or_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POEOrder']
      })
    }),
    overrideExisting: true
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOEOrdersQuery,
  useGetPOEOrderByTableQuery,
  useGetPOKOTsQuery,
  useGetPOEOrderByIdQuery,
  useGetPORunningOrdersQuery,
  useInsertPOEOrderMutation,
  useInsertPOEOrderIdemMutation,
  useInsertPOEOrderReadyMutation,
  useUpdatePOEOrderMutation,
  useUpdatePOEOrderReadyMutation,
  useDeletePOEOrderMutation
} = poeorderApi;

